<template>
  <div class="number-container">
    <el-form-item
      :style="{
        display: 'inline-block',
        // width: '130px',
        width: 'calc(50% - 27px)',
        margin: '0'
      }"
      class="el-form-item-number"
    >
      <el-input-number
        v-model="num1"
        controls-position="right"
        @change="handleChangeStart"
        :min="0"
      ></el-input-number>
    </el-form-item>
    <span
      :style="{
        display: 'inline-block',
        textAlign: 'center',
        color: '#333'
      }"
      class="line"
      >—</span
    >
    <el-form-item
      :style="{
        display: 'inline-block',
        width: 'calc(50% - 27px)',
        // width: '130px',
        margin: '0'
      }"
      class="el-form-item-number"
    >
      <el-input-number
        v-model="num2"
        controls-position="right"
        @change="handleChangeEnd"
        :min="0"
      ></el-input-number>
    </el-form-item>
    <!-- 下面的占位实现了响应式布局，因为本身整个el-form-item__content是 90%，已经少了 10% -->
    <!-- <span
      :style="{
        display: 'inline-block',
        width: '10%'
      }"
    ></span> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      num1: null,
      num2: null
    };
  },
  prop: {
    type: String,
    default: ""
  },
  methods: {
    handleChangeStart(value) {
      this.$emit("change", value, "start");
      this.$emit("input", value);
    },
    handleChangeEnd(value) {
      this.$emit("change", value, "end");
      this.$emit("input", value);
    },
    resetNumberInput() {
      this.num1 = null;
      this.num2 = null;
    }
  }
};
</script>

<style lang="scss" scoped>
.number-container {
  display: flex;
  width: 100%;
  .line {
    flex: 1;
    // transform: translate(-7px, 0);
  }
}
.el-form-item-number {
  :deep(.el-form-item__content) {
    width: 100%;
    .el-input-number {
      width: 100%;
      position: relative;
      box-sizing: border-box;
    }
    .el-input__inner {
      height: 32px;
      line-height: 32px;
      padding-left: 5px;
      padding-right: 25px;
    }
    .el-input-number__decrease {
      box-sizing: border-box;
      height: 16px;
      width: 20px;
      line-height: 16px;
      // right: 0;
      // top: 0;
      // position: absolute;
      bottom: 3px !important;
    }
    .el-input-number__increase {
      box-sizing: border-box;
      height: 16px;
      line-height: 16px;
      width: 20px;
      // right: 0;
      // bottom: 0;
      // position: absolute;
      top: 5px !important;
    }
    // .el-input {
    //   width: 100% !important;
    // }
  }
}
</style>
